import * as $ from 'jquery';
import 'jquery-colorbox';

const alertMessage = () => {
	let $elem = $('#alertMessage');
	if ($elem.length == 0) {
		return;
	}
	$.colorbox({
		transition: 'elastic',
		opacity: .60,
		fixed: true,
		speed: 450,
		initialWidth: '200',
		initialHeight: '200',
		width: 800,
		maxWidth: '90%',
		maxHeight: '90%',
		inline: true,
		href: $elem,
		open: true,
		close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" height="44" fill="#FFFFFF"><path d="M13.458 15.336l1.485-1.485 15.344 15.344-1.485 1.485z"> </path><path d="M12.961 29.2l15.344-15.343 1.485 1.485-15.344 15.344z"> </path></svg><span>Close</span>',
	});
};

export default alertMessage;